import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useCart } from "../context/CartContext";
import ProductModal from "./ProductModal";

const COLOR_MAP = {
  Purple: '#a78bfa',
  Pink: '#f472b6',
  Orange: '#fb923c',
  Yellow: '#facc15',
  Blue: '#60a5fa',
  Green: '#4ade80'
};

const ProductItem = ({ product }) => {
  const navigate = useNavigate();
  const { addToCart } = useCart();
  const [showModal, setShowModal] = useState(false);

  const handleCardClick = () => {
    navigate(`/product/${product.id}`);
  };

  return (
    <>
      <div className="shop-product-card" onClick={handleCardClick}>
        <div className="card-image-wrapper">
          <img src={product.image} alt={product.name} />
        </div>
        
        <div className="card-content">
          <h3>{product.name}</h3>

          {/* Color Palette Indicators */}
          {product.options?.colors && (
            <div className="card-color-dots">
              {product.options.colors.map(color => (
                <span
                  key={color}
                  className="color-dot"
                  style={{ backgroundColor: COLOR_MAP[color] }}
                  title={`Available in ${color}`}
                />
              ))}
            </div>
          )}

          <div className="price">{product.price}</div>
          
          <div className="card-actions-row">
            <button
              className="button card-btn primary-btn"
              onClick={(e) => {
                e.stopPropagation();
                if (product.isCustomizable) {
                  navigate(`/product/${product.id}`);
                } else {
                  addToCart(product);
                }
              }}
            >
              {product.isCustomizable ? "Customize" : "Add to Cart"}
            </button>
            <button
              className="quick-view-btn"
              onClick={(e) => {
                e.stopPropagation();
                setShowModal(true);
              }}
              title="Quick View Modal"
            >
              Quick View
            </button>
          </div>
        </div>
      </div>

      {showModal && (
        <ProductModal product={product} onClose={() => setShowModal(false)} />
      )}
    </>
  );
};

export default ProductItem;
